import * as React from "react";

function SvgInfoInCircleFilled(props) {
  return <svg width={20} height={20} viewBox="0 0 20 20" {...props}><path fill="currentColor" fillRule="nonzero" d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm1 15H9V9h2v6zm0-8H9V5h2v2z" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/info-in-circle-filled_305317.svg";
export { SvgInfoInCircleFilled as ReactComponent };